import { render, staticRenderFns } from "./ManagerRegister.vue?vue&type=template&id=cb3fbcfe"
import script from "./ManagerRegister.vue?vue&type=script&lang=js"
export * from "./ManagerRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb3fbcfe')) {
      api.createRecord('cb3fbcfe', component.options)
    } else {
      api.reload('cb3fbcfe', component.options)
    }
    module.hot.accept("./ManagerRegister.vue?vue&type=template&id=cb3fbcfe", function () {
      api.rerender('cb3fbcfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/ManagerRegister.vue"
export default component.exports